webpackJsonp([235131596041995],{

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _phaseBanner = __webpack_require__(55);
	
	var _phaseBanner2 = _interopRequireDefault(_phaseBanner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_phaseBanner2.default, { showHeaderBar: true }),
	    _react2.default.createElement(
	      'div',
	      { className: 'grid-row page-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'column-two-thirds' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'heading-xlarge' },
	          data.markdownRemark.frontmatter.title
	        ),
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: data.markdownRemark.html } })
	      ),
	      _react2.default.createElement('div', { className: 'column-one-third' })
	    )
	  );
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-page-template-js-a456f68ebb6f1219d8c0.js